import Header from "./components/Header";
import Dashboard from "./pages/Dashboard";
import SignIn from "./pages/SignIn";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import {
  ProtectedRoute,
  OnlyUnauthenticatedRoute,
} from "./routes/AuthProtectedRoutes";
import ProfileDetailView from "./pages/ProfileDetailView";
import GlobalProvider from "./context/GlobalContext";
import ModifyProfile from "./pages/ModifyProfile";
import ToastProvider from "./context/ToastContext";
import { ErrorBoundary } from "react-error-boundary";
import ErrorMessage from "./components/ErrorBoundary";
import NotFound from "./components/NotFound";
import LandingPage from "./pages/LandingPage";
import DashboardSetup from "./pages/DashboardSetup";
import ThemeProvider from "./context/ThemeProvider";
import PricingSection from "./pages/PricingPlan";
import ThankYou from "./pages/ThankYou";
import SignUp from "./pages/SignUp";
import Users from "./pages/Users";

export default function App() {
  return (
    <ErrorBoundary fallback={<ErrorMessage />}>

      <GlobalProvider>
        <ToastProvider>
          <ThemeProvider>
            <Router>
              <Header />
              <Routes>
                {/* Unauthenticated Routes */}
                <Route element={<OnlyUnauthenticatedRoute />}>
                  <Route path="/login" element={<SignIn />} />
                  <Route path="/" element={<LandingPage />} />
                  <Route path="/sign-up" element={<SignUp />} />
                </Route>
                {/* Public Routes */}
                <Route
                  path="/profile-detail/:id"
                  element={<ProfileDetailView />}
                />
                <Route path="*" element={<NotFound />} />
                {/* Protected Routes */}
                <Route element={<ProtectedRoute />}>
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/dashboard-setup" element={<DashboardSetup />} />
                  <Route path="/modify-profile/:id" element={<ModifyProfile />} />
                  <Route path="/pricing-plan" element={<PricingSection />} />
                  <Route path="/users" element={<Users />} />
                  <Route path="/thank-you" element={<ThankYou />} />
                </Route>
              </Routes>
            </Router>
          </ThemeProvider>
        </ToastProvider>
      </GlobalProvider>
    </ErrorBoundary>
  );
}
